/**
 * Custom fetch wrapper for admin API endpoints.
 * Automatically retrieves the current user's Firebase ID token and attaches it
 * as an Authorization: Bearer <token> header.
 */
export async function adminFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  let user: any = null;
  try {
    const { auth } = await import('@/lib/firebase');
    user = auth.currentUser;

    // If Firebase Auth is still restoring state asynchronously, wait for it
    if (!user && typeof (auth as any)?.authStateReady === 'function') {
      try {
        await auth.authStateReady();
        user = auth.currentUser;
      } catch (err) {
        console.warn('[adminFetch] Notice: authStateReady error:', err);
      }
    }
  } catch (err) {
    //
  }

  const headers = new Headers(init?.headers || {});

  if (user) {
    try {
      const token = await user.getIdToken();
      headers.set('Authorization', `Bearer ${token}`);
    } catch (err) {
      console.warn('[adminFetch] Notice: Failed to attach Firebase ID token to admin request:', err);
    }
  }

  return fetch(input, {
    ...init,
    headers,
  });
}
